import type { PublicNavigationLink } from "app/router/public/types";

export const investorNavigationLinks: PublicNavigationLink[] = [
  // { label: "Fundos de Investimento", page: "fundos" },
  // { label: "Assembleias e Eventos", page: "eventos" },
  { label: "Títulos de Dívida", page: "titulos" },
];

export const governanceNavigationLinks: PublicNavigationLink[] = [
  { label: "Política de Privacidade", page: "privacidade-lgpd" },
  { label: "Ouvidoria", page: "ouvidoria" },
  { label: "Canal de Denúncias", page: "canal-denuncias" },
  { label: "Centro de Ajuda", page: "centro-ajuda" },
  { label: "Informações Regulatórias", page: "informacoes-regulatorias" },
  { label: "Transparência", page: "transparencia" },
];

export const institutionalNavigationLinks: PublicNavigationLink[] = [
  { label: "Quem somos", page: "quem-somos" },
  { label: "Registro e custódia", page: "solucao-registro-custodia" },
  { label: "Escrituração", page: "solucao-escrituracao" },
  { label: "Títulos de dívida", page: "solucao-titulos-divida" },
  { label: "Fale conosco", page: "fale-conosco" },
];
